<template>
  <div
    ref="refMe"
    :class="{
       'cursor-pointer': canBeUnlocked
    }"
    :style="`left:${posX}px; top:${posY}px; width:${size}px; height:${size}px`"
    :title="canBeUnlocked ? 'Click to unlock' : null"
    class="expansion z-2 absolute flex flex-row items-center justify-center bg-grid group"
    @click="unlockExpansion"
  >
    <div class="relative text-yellow-400 text-xs">
      <img
        :src="require('@/assets/images/icon/Expansion.webp')"
        alt=""
        class="w-8 h-8 opacity-25 group-hover:opacity-100 transition duration-300"
      >
      <i
        :class="{
          'fa-lock': !canBeUnlocked,
          'fa-lock-open': canBeUnlocked
        }"
        class="fas absolute -right-1 -bottom-1 opacity-25 group-hover:opacity-100"
      />
    </div>
  </div>
</template>

<script>
import Grid from '@/roc/grid/Grid';
import {computed, onBeforeUnmount, ref, watch} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';

export default {
  props: {
    tileX: {
      type: Number,
      required: true
    },
    tileY: {
      type: Number,
      required: true
    },
    expansionId: {
      type: String,
      required: true
    }
  },
  emits: ['unlock'],
  setup(props, context) {
    const appStore = useApplicationStore();

    const isReachable = ref(false);
    const refMe = ref(null);
    let threadId = null;

    const canBeUnlocked = computed(() => {
      return appStore.editable && isReachable.value;
    });

    const removeThread = () => {
      if (threadId) {
        clearInterval(threadId);
        threadId = null;
      }
    };

    const checkAdjacentBuildings = () => {
      let hasTileAbove = false;
      let hasTileBelow = false;
      let hasTileLeft = false;
      let hasTileRight = false;

      if (props.tileY > 0) {
        const element = document.querySelector('[data-tile-x="' + props.tileX + '"][data-tile-y="' + (props.tileY - Grid.EXPANSION_SIZE) + '"]');
        hasTileAbove = element !== null;
      } else {
        hasTileAbove = true;
      }

      if (props.tileY < Grid.CELL_COUNT_Y - Grid.EXPANSION_SIZE) {
        const element = document.querySelector('[data-tile-x="' + props.tileX + '"][data-tile-y="' + (props.tileY + Grid.EXPANSION_SIZE) + '"]');
        hasTileBelow = element !== null;
      } else {
        hasTileBelow = true;
      }

      if (props.tileX > 0) {
        const element = document.querySelector('[data-tile-x="' + (props.tileX - Grid.EXPANSION_SIZE) + '"][data-tile-y="' + props.tileY + '"]');
        hasTileLeft = element !== null;
      } else {
        hasTileLeft = true;
      }

      if (props.tileX < Grid.CELL_COUNT_X - Grid.EXPANSION_SIZE) {
        const element = document.querySelector('[data-tile-x="' + (props.tileX + Grid.EXPANSION_SIZE) + '"][data-tile-y="' + props.tileY + '"]');
        hasTileRight = element !== null;
      } else {
        hasTileRight = true;
      }

      if (hasTileAbove && hasTileLeft && hasTileRight && hasTileBelow) {
        isReachable.value = false;
      } else {
        isReachable.value = true;
      }

      // if (hasTileAbove) {
      //   refMe.value.style.borderTop = 'red 1px solid';
      // }
      // if (hasTileBelow) {
      //   refMe.value.style.borderBottom = 'red 1px solid';
      // }
      // if (hasTileLeft) {
      //   refMe.value.style.borderLeft = 'red 1px solid';
      // }
      // if (hasTileRight) {
      //   refMe.value.style.borderRight = 'red 1px solid';
      // }
    };

    onBeforeUnmount(() => {
      removeThread();
    });

    watch(() => appStore.editable, (val) => {
      if (val) {
        if (threadId === null) {
          const i = setInterval(() => {
            if (refMe.value) {
              threadId = setInterval(checkAdjacentBuildings, 1000);
              clearInterval(i);
            }
          }, 5);
        }
      } else {
        removeThread();
      }
    }, {immediate: true});

    return {
      refMe,

      posX: computed(() => {
        return props.tileX * Grid.CELL_SIZE + 1;
      }),
      posY: computed(() => {
        return props.tileY * Grid.CELL_SIZE + 1;
      }),
      size: computed(() => {
        return Grid.CELL_SIZE * Grid.EXPANSION_SIZE - 1;
      }),
      canBeUnlocked,

      unlockExpansion() {
        if (canBeUnlocked.value) {
          context.emit('unlock', props.expansionId);
        }
      }
    };
  }
};
</script>
